<template>
  <div>
    <p>Sends Message to all Subscribers. only 30 messages can be sent in 1 second. using this method for publishing to large number of Subscribers is not recommended. Insted use Telegram channels to reach larger audience.</p>
    <Message :text="data.text" @updateMessage="data.text = $event"></Message>
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup=$event"></ReplyMarkup>
  </div>
</template>


<script type="text/javascript">
  import Message from '@/components/tasks/fields/Message.vue'
  import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'

  export default {
    name: 'Publish',
    components: {
      Message,
      ReplyMarkup
    },
    props: {
      data: Object,
      actions: Object
    },
    data: function() {
      return {

      }
    }
  }
</script>
